/**
 * @generated SignedSource<<6f47ad89c0db6b94e62d63adfa2553f8>>
 * @relayHash f5c717e923bf00b11aaaea19cf66c689
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8dafa511b8390ff5efc8841fc0285b2f3680e5c85163429e75d63d002faa5ff5

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type AgentIdentityAvatarQuery$variables = {
  accountId: string;
};
export type AgentIdentityAvatarQuery$data = {
  readonly user: {
    readonly picture: AGG$URL;
    readonly " $fragmentSpreads": FragmentRefs<"avatarRelay_user">;
  } | null;
};
export type AgentIdentityAvatarQuery = {
  response: AgentIdentityAvatarQuery$data;
  variables: AgentIdentityAvatarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountId",
    "variableName": "accountId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "picture"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "AgentIdentityAvatarQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "avatarRelay_user"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgentIdentityAvatarQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "__typename"
          },
          (v2/*: any*/),
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isUser"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "kind": "ScalarField",
                "name": "appType"
              }
            ],
            "type": "AppUser"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "f5c717e923bf00b11aaaea19cf66c689",
    "id": "8dafa511b8390ff5efc8841fc0285b2f3680e5c85163429e75d63d002faa5ff5",
    "metadata": {},
    "name": "AgentIdentityAvatarQuery",
    "operationKind": "query",
    "text": "query AgentIdentityAvatarQuery($accountId:ID!){user(accountId:$accountId){__typename,picture,...avatarRelay_user,id}}fragment avatarRelay_user on User{__isUser:__typename,picture,...on AppUser{appType}}"
  }
};
})();

(node as any).hash = "bc56858ea415054ebfcd1ab9f95ed2b4";

export default node;
